import { getApi } from "../../services/httpService";


export function quickMoveDataInfo(data){
    return getApi().post('home/filterValue/floorPlanList/quickIn/filter',data);
}
